import { Component, OnInit, OnDestroy, ViewChild, HostListener, Inject, PLATFORM_ID, ElementRef, DoCheck,ChangeDetectorRef, AfterViewInit, Renderer2 } from '@angular/core'; 
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Settings, AppSettings } from 'src/app/app.settings';
import { SidenavMenuService } from 'src/app/theme/components/sidenav-menu/sidenav-menu.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteCartComponent } from 'src/app/shared/cart/delete-cart/delete-cart.component';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/shared/services/notification.service';
import {
  explode, strReplace, implode, getLocalStorage,
  checkLessThanCutOffTime, checkDeliveryCalenderAndCutOffTime
} from 'src/app/theme/utils/util-functions';
import { ScreenBreakpoint } from 'src/app/theme/utils/screen-breakpoint';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { DatePipe, DecimalPipe, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Subscription, Observable, Subject } from 'rxjs';
import { AppHeaderService } from 'src/app/theme/utils/app-header.service';
import { ReplacePipe } from 'src/app/theme/pipes/replace.pipe';
import { Meta, Title } from '@angular/platform-browser';
import { debounceTime, filter, map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { SearchProductsComponent } from 'src/app/shared/search-products/search-products.component';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { MatMenuTrigger } from '@angular/material/menu';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { DynamicStyleService } from 'src/app/theme/utils/dynamic-styles.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [SidenavMenuService]

})
export class LittlefarmHeaderComponent implements OnInit {

  public isMobile = false;
  public categories = [];
  public category = {};
  public sidenavMenuItems = {};
  routerSubscription: Subscription;
  searchForm: FormGroup;
  loggedIn;
  sub;
  profileImage = environment.sideNavProfileImage;
  url = this.router.url.split('?')[0];
  localStorageCartProd;
  localStorageDetails = {};
  totalCartCount = 0;
  cartProducts = [];
  currentWeekRecurringProducts = [];
  skippedProducts = [];
  skippedProductPrice: number = 0;
  notThisWeekProducts = [];
  notThisWeekProductsId = [];
  subTotal: number = 0;
  grandTotal: number = 0;
  recurringSubTotal: number = 0;
  totalBottles = [];
  totalBottlesCount: number = 0;
  totalBottlePrice: number = 0;
  totalCartBottlesCount: number = 0;
  totalRecrringBottlesCount: number = 0;
  cartProductPrice: number = 0;
  deliveryFee = 0;
  totalTaxCollectedAmount: number = 0;
  recurringItems = [];
  recurringProductPrice: number = 0;
  innerHtml;
  totalPrice = 0;
  categorySearchValues = {};
  storeDetailsJson = {};
  storeDetails = {};
  userDetails = {};
  cutOffTime = [];
  subService;
  loginSubService;
  params = {};
  categoryToolbarDatas: Array<any> = null;
  selectedDeliveryCalendar = {};
  featureTags = {};
  public vendors = [];
  public pageTitle: string;
  public breadcrumbs: {
    name: string;
    url: string
  }[] = [];
  @ViewChild('sidenav', { static: true }) sidenav: any;
  @ViewChild('searchProductsInDesktopView', { read: ElementRef }) searchProductsDesktop: ElementRef;
  @ViewChild('searchProductsInMobileView', { read: ElementRef }) searchProductsMobile: ElementRef;
  // @ViewChildren(MatMenuTrigger) subcategoriesMenu: QueryList<MatMenuTrigger>;
  @ViewChild('allCategoriesMenuTrigger') allCategoriesMenuTrigger!: MatMenuTrigger;
  showSearchProductsResult: boolean = false;
  public settings: Settings;
  isShowSearch = false;
  enableRSMenu = false;
  brands = []
  private Evsubscription: Subscription;
  isCmsView = false;
  Menus: any = {};
  MenusHeight: any = {};
  public screenWidth: any;
  public screenHeight: any;
  wholeaccess: any[] = [];
  device: String;
  // wordWidths: Map<string, number> = new Map<string, number>();
  private lastScrollTop: number = 0;
  wordWidths: Map<string, number> = new Map();
  totalWidth: number = 0;
  indexToRemove: number = -1;
  chk: boolean = true;
  finwidth: number = 1000; // Set your desired width
  cartData = {
    items: 0,
    total: 0.00
  };
  // sortedProducts: { category_name: string }[] = [/* Your products here */];
  canvas: HTMLCanvasElement;
  showCategories = true;
  cmsUrls: string[] = [
    '/index',
    '/about-us',
    '/our-services',
    '/faq',
    '/themarket',
    '/terms-and-conditions',
    '/privacy-policy',
    '/refund-policy',
    '/cancellation-policy',
    '/account-setup'
  ];
  hoveredIndex: number | null = null;
  hoveringAllCategory = false;
  enteredButton = false;
  isMatMenuOpen = false;
  isMatMenu2Open = false;
  prevButtonTrigger;
  creditCards = [];
  creditCardsNotFound: boolean = false;
  ccExpired:boolean;
  unsavedChanges: boolean = true;
  themeType:string | undefined ;
  private destroy$ = new Subject<void>();

  constructor(
    public appSettings: AppSettings,
    private apiService: ApiService,
    private subscription: SubscriptionService,
    public sidenavMenuService: SidenavMenuService,
    private formBuilder: FormBuilder,
    private notification: NotificationService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private replacePipe: ReplacePipe,
    private decimalPipe: DecimalPipe,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private meta: Meta,
    private title: Title,
    private screenBreakpoint: ScreenBreakpoint,
    private cookieService: CookieService,
    private appHeaderService: AppHeaderService,
    public sharedDataService: SharedDataService,
    public styleService: DynamicStyleService,
    private titleService: ApiService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private ref: ChangeDetectorRef, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) {
    this.settings = this.appSettings.settings; 
  }

  ngDoCheck(): void {
    this.isShowSearch = JSON.parse(localStorage.getItem('checkVal'));
  }

  getAppTitleFromRoute() {
    let child = this.activatedRoute.firstChild;
    while (child.firstChild) {
      child = child.firstChild;
    }
    if (child.snapshot.data['title']) {
      return child.snapshot.data['title'];
    }
    return null;
  }
  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));    
    this.setFavicons();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: NavigationEnd) => {
        this.activatedRoute.data
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          if(event.url.startsWith('/account-setup')){
            this.showCategories = false
            this.isCmsView = true
          }else{
            this.showCategories = !this.cmsUrls.includes(event.url);
    
          }
        })
        if (event.url === '/index') {
          this.sharedDataService.isCmsView.next(true)
        } else {
          this.sharedDataService.isCmsView.next(false)
        }
      });
    this.setCategoryValue();
    
    this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
    this.activatedRoute.data
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if(this.router.url.startsWith('/account-setup')){
        this.showCategories = false
        this.isCmsView = true
      }else{
        this.showCategories = !this.cmsUrls.includes(this.router.url);

      }

      this.storeDetails = data?.store?.response?.data?.store || {};
      this.storeDetailsJson = data?.store?.response?.data?.store_json || {};
      sessionStorage.setItem('store', JSON.stringify(this.storeDetails)); //this is store the store details when we come through impersonate customer
      this.getUserDetails();

    })
    if (!!this.cookieService.get('rememberMe')) {
      const rememberMe = JSON.parse(this.cookieService.get('rememberMe'));
      if (!!rememberMe) {
        this.subscription.subjectNext({ loginwithRememberMe: true });
      }
    }

    // if (this.userDetails?.response?.status === 1) {
    //   this.userDetails = this.userDetails?.response?.data?.users;

    //   if (Object.keys(this.userDetails['cus_type_details']).length > 0) {
    //     this.storeDetails['delivery_fee'] = this.userDetails['cus_type_details']['delivery_fee'];
    //     this.storeDetails['delivery_upper_limit'] = this.userDetails['cus_type_details']['delivery_upper_limit'];
    //     this.storeDetails['rate_per_bottle'] = this.userDetails['cus_type_details']['rate_per_bottle'];
    //   }
    //   if (this.activatedRoute.snapshot['data']['user']['response']['data']['store_delivery_date'] !== null) {
    //     var cutOffTime = [{
    //       storeCutOffTime: this.activatedRoute.snapshot['data']['user']['response']['data']['store_date_time']['date'],
    //       currentDateAndtime: this.activatedRoute.snapshot['data']['user']['response']['data']['current_date_time']['date'],
    //       orderDeliveryDate: this.activatedRoute.snapshot['data']['user']['response']['data']['delivery_date'],
    //       storeDeliveryDate: this.activatedRoute.snapshot['data']['user']['response']['data']['store_delivery_date'],
    //     }];
    //     sessionStorage.setItem('cutoff', JSON.stringify(cutOffTime));
    //   }
    // }

    this.deliveryFee = this.storeDetails['delivery_fee'];
    this.searchForm = this.formBuilder.group({
      keyword: ''
    });
    if (sessionStorage.getItem('cart')) {
      if (JSON.parse(sessionStorage.getItem('cart')).length > 0 && JSON.parse(sessionStorage.getItem('cart')) !== null) {
        if (this.featureTags && this.featureTags['sf_cart_page_update']) {
          const cart = sessionStorage.getItem('cart');
          const cartItems = cart ? JSON.parse(cart) : [];
          if (cartItems.length > 0) {
            this.cartData = {
              items: cartItems.length,
              total: 0.00
            };
          }
        }
        this.getLocalStorage();
      }
    }
    
    if(this.apiService.loggedIn()){
      if (isPlatformBrowser(this.platformId)) {
        this.getDeliveryDates();
        this.getOrdercountDetails();
      }
    }

    this.sharedDataService.cartDataSource
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      if (data) {
        this.cartData = data;
      } else {
        this.cartData = {
          items: 0,
          total: 0.00
        };

      }
    });
    this.sharedDataService.sidenavToggle$
    .pipe(takeUntil(this.destroy$))
    .subscribe(open => {
      if (open) {
        this.sidenav.open();
      } else {
        this.sidenav.close();
      }
    });
   
    this.isMobile = this.screenBreakpoint.checkScreenBreakpoint('screen and (max-width: 959px)');
    this.sub = this.activatedRoute.queryParams
    .pipe(takeUntil(this.destroy$))
    .subscribe(params => {
      this.searchForm.patchValue({ keyword: !!params['keyword'] ? params['keyword'] : '' });
    });
    this.sub = this.activatedRoute.params
    .pipe(takeUntil(this.destroy$))
    .subscribe(params => {
      this.params = params
    });
    this.loginSubService = this.apiService.getLogin().subscribe(message => {
      this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
      this.loggedIn = message['loggedIn'];
      if (this.loggedIn === true) {
        this.userDetails = message['userDetails'];
        if(!!this.featureTags && this.featureTags['sf_hide_previously_ordered']){
        this.getCategories();
        }
        this.getOrdercountDetails();
      }
      if (this.loggedIn === false) {
        this.cartProducts = [];
        if(!!this.featureTags && this.featureTags['sf_hide_previously_ordered']){
        this.getCategories();
        }
      }

    });
    this.getCategories();
    if (this.vendors.length === 0) {
      this.getBrands()
    }
    this.sidenavMenuService.getSidenavMenuItems()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        if (this.featureTags && this.featureTags['sf_desktop_sub_cat'] === true) {
          this.sidenavMenuItems = this.newcutomizeMenuDetails(result['response']['data']['menus']['menus']);
        } else {
          this.sidenavMenuItems = this.cutomizeMenuDetails(result['response']['data']['menus']['menus']);

        }
      }
    });

    this.subService = this.subscription.getSubject().subscribe(val => {
      this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
      if (val['vendors']) {
        this.vendors = val['vendors'];
      }
      if (val['cartProducts']) {
        this.cartProducts = val['cartProducts'];
        this.totalCartCount = this.cartProducts.length;
        this.totalPrice = this.cartProducts.reduce((total, currentValue) => {
          let price = this.decimalPipe.transform(this.decimalPipe.transform(currentValue['quantity'] * currentValue['product']['retail_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
          return total + parseFloat(price);
        }, 0);
      }
      if (val['getUser']) {
        this.getUserDetails();
      }
      if (val['cartlength'] >= 0) {
        this.getLocalStorage();
        this.totalCartCount = val['cartlength']
      }
      if (val['info'] === 'cart delete all') {
        this.totalCartCount = 0;
        this.totalPrice = 0;
        this.cartProducts = [];
      }
      if (val['value'] === 'Get cart') {
        this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff'));
        if (this.loggedIn === false) {
          this.getLocalStorage();
        }
      }
      if (val['msg'] === 'logged out') {
        this.totalCartCount = 0;
      }
      if (val['categorySearch'] || val['productSearch']) {
        var catUrl = val['categorySearch'] ? val['cat_url'] : val['productSearch'];
        if (catUrl !== 'All_Categories') {
          this.getcategoryMatch(catUrl);
        }
      }
      if (!!val['setbreadcrumb']) {
        this.setBreadcrumb();
        this.showCategoryToolbar();
        this.categoriesToolbar();
      }

    });
    // this.getCartDetails();
    // set app title in dynamically
    // when page is reload then call this function
    this.appHeaderService.setupAppHeader(this.storeDetailsJson, this.categories, this.vendors);
    // whenever the routes changed call this function
    this.router.events
    .pipe(takeUntil(this.destroy$))
    .subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.settings['gaTrackingShow'] === 'yes') {
          (window as any).ga('set', 'page', event.urlAfterRedirects);
          (window as any).ga('send', 'pageview');
        }
        this.appHeaderService.setupAppHeader(this.storeDetailsJson, this.categories, this.vendors);
        this.setBreadcrumb();
        if (event.url === '/categories' || event.url.includes('account') || event.url === '/sign-in' || event.url === '/contact' || event.url === '/edit-order') {
          this.setCategoryValue();
        }
      }
    });
    // end
    this.setBreadcrumb();
    this.Evsubscription = this.apiService.getEvent().subscribe(val => {
      this.enableRMenu();
    });
    // if (isPlatformBrowser(this.platformId)) {
    //   document.getElementById('rootEl').classList.add("hudsonMilkTheme");
    // }
    this.loggedIn = this.apiService.loggedIn();
  }


  @HostListener('click', ['$event'])
  onClick(e: MouseEvent) {
    // this.closeAllMenus();
    let isMobileDevice = this.screenBreakpoint.checkScreenBreakpoint('screen and (max-width: 959px)');
    // let mobileSearchProducts = this.searchProductsMobile.nativeElement.contains(e.target);

    var desktopSearchProducts;
    if (!!this.searchProductsDesktop) {
      desktopSearchProducts = this.searchProductsDesktop.nativeElement.contains(e.target) ? this.searchProductsDesktop.nativeElement.contains(e.target) : "";
    }
    if (!isMobileDevice && desktopSearchProducts) {
      this.showSearchProductsResult = true;
    } else {
      this.showSearchProductsResult = false;
    }
  }


  setBreadcrumb() {
    this.breadcrumbs = [];

    let parentCategory;
    let childCategory;
    if (!!this.featureTags && this.featureTags['sf_seo']) {
      let urlSegments = this.router.url.split('/');
      parentCategory = urlSegments.length === 3 && this.router.url !== '/categories' && this.router.url.includes('categories') 
        ? this.categories.filter(val => val['category_url'] === urlSegments[2].split('?')[0]) 
        : undefined;
  
      // Extract the child category, if available
      childCategory = urlSegments.length > 3 && this.router.url !== '/categories' && this.router.url.includes('categories') 
        ? (() => {
            const potentialChild = urlSegments[3]; // this is where "page=2" would break your logic
            const childSegment = potentialChild.includes('?') ? potentialChild.split('?')[0] : potentialChild; // strip out query params
            return isNaN(parseInt(childSegment)) 
              ? this.categories.reduce((arr, item) => arr.concat(item.sub_list), []).find(sub => sub.category_url === childSegment) 
              : this.vendors.filter(el => el['id'] === parseInt(childSegment));
          })()
        : undefined;
    }else{
      parentCategory = this.router.url.split('/').length === 3 && this.router.url !== '/categories' && this.router.url.includes('categories') ? this.categories.filter(val => val['category_url'] === this.router.url.split('/')[2]) : undefined;
      childCategory = this.router.url.split('/').length > 3 && this.router.url !== '/categories' && this.router.url.includes('categories') && isNaN(parseInt(this.router.url.split('/')[3])) ? this.categories.reduce((arr, item) => arr.concat(item.sub_list), []).find(sub => sub.category_url === this.router.url.split('/')[3]) : this.vendors.filter(el => el['id'] === parseInt(this.router.url.split('/')[3]));
    }

    if (!!parentCategory && parentCategory.length !== 0) {
      this.breadcrumbs.push({
        name: parentCategory[0]['category_name'].replace('&amp;', '&'),
        url: '/' + this.router.url.split('/')[2]
      })
    } else if (!!childCategory && childCategory.length !== 0 && isNaN(parseInt(this.router.url.split('/')[3]))) {
      let parentCategoryName = this.categories.filter(val => val['category_url'] === this.router.url.split('/')[2])
      this.breadcrumbs.push({
        name: parentCategoryName[0]['category_name'].replace('&amp;', '&'),
        url: '/categories/' + this.router.url.split('/')[2]
      }, {
        name: childCategory['category_name'],
        url: '/' + this.router.url.split('/')[3]
      })
    } else if (childCategory && childCategory.length !== 0 && isNaN(parseInt(this.router.url.split('/')[3])) === false) {
      this.setCategoryValue();
      this.breadcrumbs.push({
        name: childCategory[0]['vendor_name'].replace('&amp;', '&'),
        url: '/categories/' + this.router.url.split('/')[2].replace(/[\s&/]+/g, '-') + '/' + this.router.url.split('/')[3]
      })
    } else {
      if (this.router.url.split('/').length > 2 && this.router.url.includes('products')) {
        if (this.router.url.includes('search')) {
          let routeTitle = this.getAppTitleFromRoute();
          let url = this.router.url.includes('account') ? `${this.router.url.split('/')[1]}/${this.router.url.split('/')[2]}` : this.router.url.split('/')[1];
          this.breadcrumbs.push({
            name: routeTitle,
            url: '/' + url
          })
        } else {
          let routeTitle = this.getAppTitleFromRoute();
          let url = this.router.url.includes('products') ? `${this.router.url.split('/')[1]}/${this.router.url.split('/')[2]}` : this.router.url.split('/')[1];
          this.breadcrumbs.push({
            name: routeTitle,
            url: '/products'
          }, {
            name: url.split('/')[1].replace(/-+/g, ' ').trim(),
            url: '/'
          })
        }
      } else {
        if (!!this.featureTags && this.featureTags['sf_vendor_page']) {
          if (!!this.featureTags && this.featureTags['ftag_sf_manufacturer_list']) {
            if (this.router.url.startsWith('/vendors/') && this.router.url !== '/vendors') {
              const vendorSlug = this.router.url.split('/vendors/')[1];
              const vendor = this.vendors.find(v => v.vendor_url === vendorSlug);
              if (vendor) {
                let routeTitle = this.getAppTitleFromRoute();
                this.breadcrumbs.push({
                  name: routeTitle,
                  url: '/vendors'
                },{
                  name: vendor.vendor_name,
                  url: '/'
                })
              }else{
                let routeTitle = this.getAppTitleFromRoute();
                this.breadcrumbs.push({
                  name: routeTitle,
                  url: '/vendors'
                })
              }
            }else if(this.router.url.startsWith('/producers/') && this.router.url !== '/producers'){
              const producerSlug = this.router.url.split('/producers/')[1];
              const producer = this.vendors.find(v => v.vendor_url === producerSlug);
              if (producer) {
                let routeTitle = this.getAppTitleFromRoute();
                this.breadcrumbs.push({
                  name: routeTitle,
                  url: '/producers'
                },{
                  name: producer.vendor_name,
                  url: '/'
                })
              }else{
                let routeTitle = this.getAppTitleFromRoute();
                this.breadcrumbs.push({
                  name: routeTitle,
                  url: '/producers'
                })
              }
            }else{
              let routeTitle = this.getAppTitleFromRoute();
              let url = this.router.url.includes('account') ? `${this.router.url.split('/')[1]}/${this.router.url.split('/')[2]}` : this.router.url.split('/')[1];
              this.breadcrumbs.push({
                name: routeTitle,
                url: '/' + url
              })  
            }
          }else{
            if (this.router.url.startsWith('/vendors/') && this.router.url !== '/vendors') {
              const vendorSlug = this.router.url.split('/vendors/')[1];
              const vendor = this.vendors.find(v => v.vendor_url === vendorSlug);
              if (vendor) {
                let routeTitle = this.getAppTitleFromRoute();
                this.breadcrumbs.push({
                  name: routeTitle,
                  url: '/vendors'
                },{
                  name: vendor.vendor_name,
                  url: '/'
                })
              }else{
                let routeTitle = this.getAppTitleFromRoute();
                this.breadcrumbs.push({
                  name: routeTitle,
                  url: '/vendors'
                })
              }
            }else{
              let routeTitle = this.getAppTitleFromRoute();
              let url = this.router.url.includes('account') ? `${this.router.url.split('/')[1]}/${this.router.url.split('/')[2]}` : this.router.url.split('/')[1];
              this.breadcrumbs.push({
                name: routeTitle,
                url: '/' + url
              })  
            }
          }
        }else{
          let routeTitle = this.getAppTitleFromRoute();
          let url = this.router.url.includes('account') ? `${this.router.url.split('/')[1]}/${this.router.url.split('/')[2]}` : this.router.url.split('/')[1];
          this.breadcrumbs.push({
            name: routeTitle,
            url: '/' + url
          })
        }
      }
    }
    // this.parseRoute(this.router.routerState.snapshot.root); 

  }
  setCategoryValue() {
    this.category = {
      id: -1,
      'category_url': 'All_Categories',
      parentId: 0,
      'category_name': 'All Categories',
      'sub_list': []
    }
  }
  getUserDetails() {
    if(isPlatformBrowser(this.platformId)){
      this.apiService.getAutheticatedUserDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data['response']['status'] === 1) {
          this.userDetails = data['response']['data']['users'];
          if (Object.keys(this.userDetails['cus_type_details']).length > 0) {
            this.storeDetails['delivery_fee'] = this.userDetails['cus_type_details']['delivery_fee'];
            this.storeDetails['delivery_upper_limit'] = this.userDetails['cus_type_details']['delivery_upper_limit'];
            this.storeDetails['rate_per_bottle'] = this.userDetails['cus_type_details']['rate_per_bottle'];
          }
          var cutOffTime = [{
            storeCutOffTime: data['response']['data']['store_date_time']['date'],
            currentDateAndtime: data['response']['data']['current_date_time']['date'],
            orderDeliveryDate: data['response']['data']['delivery_date'],
            storeDeliveryDate: data['response']['data']['store_delivery_date']
          }];
          if (data['response']['data']['store_delivery_date'] !== null) {
            sessionStorage.setItem('cutoff', JSON.stringify(cutOffTime));
          }
        }
      }, err => { })
    }
  }
  // getCartDetails() {
  //   // if(this.featureTags && this.featureTags['move_cart_to_rightside_bar'] === true){
  //   var query = {};
  //   if (this.loggedIn === true) {
  //     // this.getCartcountDetails();
  //     this.subscription.getSharedData().subscribe(result => {
  //       this.cartProducts = [];
  //       if (result['status'] === 1) {
  //         this.notThisWeekProducts = result['data']['cart_product_list'].map(val => {
  //           if (val['auto_generate'] === true) {
  //             this.notThisWeekProductsId.push(val['product']['id']);
  //             return val;
  //           } else if (val['auto_generate'] === false) {
  //             val['isDisabled'] = true;
  //             val['is_recurring'] = 0;
  //             // val['quantityArray'] = this.calculateAvailableQuantityFast(val);
  //             this.cartProducts.push(val);
  //           }
  //         }).filter(val => val !== undefined);
  //         this.cartProducts = result['status'] === 0 ? [] : this.cartProducts;

  //         if (!!result['data']['tax_details'] && !!result['data']['tax_details']['tax_collected_amount'] && result['data']['tax_details']['tax_collected_amount'] > 0) {
  //           this.totalTaxCollectedAmount = result['data']['tax_details']['tax_collected_amount'];
  //         }
  //         this.totalBottles = this.cartProducts.filter(val => {
  //           if (val['product']['bottle_charge'] === true) {
  //             return parseInt(val['bottleQty']);
  //           }
  //         });
  //         this.subscription.subjectNext({ cartProducts: this.cartProducts });

  //         this.totalCartBottlesCount = this.cartProducts.reduce((a, val) => a + parseInt(val['bottleQty']), 0);
  //         this.calculateRecurring(result['data']['recurring_items']);
  //         this.totalRecrringBottlesCount = this.currentWeekRecurringProducts.filter(el => el['product']['bottle_charge']).reduce((a, val) => a + parseFloat(val['quantity']), 0);
  //         this.calculateTotal();
  //       } else {
  //         this.notThisWeekProducts = [];
  //         this.notification.warning(result['message'], 5000)
  //       }
  //     }, (error) => { });
  //   }

  //   this.calculateTotal();
  //   // }
  // }
  // getCartcountDetails() {
  //   let query = {};
  //   this.apiService.getCart(query).subscribe(data => {
  //     if (data['response']['status'] === 1) {
  //       let cartList = data['response']['data']['cart_product_list'];
  //       sessionStorage.setItem('cart', JSON.stringify(data['response']['data']['cart_product_list']));
  //       let cartItem = { items: cartList.length, total: 0 };
  //       this.sharedDataService.cartDataSource.next(cartItem);
  //     }
  //   });
  // }
  calculateRecurring(recurringProducts) {
    this.recurringItems = recurringProducts['recurring_products'];
    this.skippedProducts = recurringProducts['skipped_recurring_products'];
    this.recurringProductPrice = this.recurringItems.reduce((a, val) => a + parseFloat(this.decimalPipe.transform(this.decimalPipe.transform(val['extended_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '')), 0);

    this.skippedProductPrice = this.skippedProducts.reduce((a, val) => a + parseFloat(this.decimalPipe.transform(this.decimalPipe.transform(val['extended_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '')), 0);
    if (checkDeliveryCalenderAndCutOffTime() === true) {
      this.currentWeekRecurringProducts = this.notThisWeekProducts.filter(val => val !== undefined);
      this.currentWeekRecurringProducts = this.currentWeekRecurringProducts.filter(item1 =>
        this.recurringItems.map(item2 => {
          if (item2['product'].id === item1['product'].id) {
            item1['last_recurring_date'] = item2['last_recurring_date'];
            item1['recurring_date'] = item2['recurring_date'];
            item1['saleId'] = item1['id'];
            item1['recurringId'] = item2['id'];
            item1['recurring_qty'] = item2['quantity']
            return item1;
          } else if (item2['product'].id !== item1['product'].id && (this.currentWeekRecurringProducts.findIndex(el => el['product']['id'] === item2['product'].id) < 0)
            && (this.cartProducts.findIndex(el => el['product']['id'] === item2['product'].id) < 0)) {
            const j = this.skippedProducts.findIndex(val => val['product']['id'] === item2['product']['id']);
            if (j < 0) {
              this.skippedProducts.push(item2);
            }
          }
        })
      );
    } else {
      this.currentWeekRecurringProducts = this.recurringItems.filter(val => {
        let index = this.notThisWeekProductsId.indexOf(val['product']['id']);
        let productIndex = this.notThisWeekProducts.filter(val => val !== undefined).findIndex(el => el['product']['id'] === val['product']['id']);
        if (this.datePipe.transform(val['delivery_date'], 'yyyy-MM-dd') === val['recurring_date'] || this.notThisWeekProductsId.indexOf(val['product']['id']) >= 0) {
          val['recurring_qty'] = val['quantity']
          if (productIndex >= 0 && this.notThisWeekProducts[productIndex] !== undefined) {
            val['recurring_date'] = val['delivery_date'];
            val['quantity'] = this.notThisWeekProducts[productIndex]['quantity'];
            val['frequency'] = this.notThisWeekProducts[productIndex]['frequency'];
            val['cartId'] = this.notThisWeekProducts[productIndex]['id'];
            val['extended_price'] = this.notThisWeekProducts[productIndex]['extendedprice'];
          }
          val['is_recurring'] = 1;
          return val;

        } else {
          if (this.datePipe.transform(val['delivery_date'], 'yyyy-MM-dd') !== val['recurring_date']) {
            const i = this.skippedProducts.findIndex(el => el['product']['id'] === val['product']['id']);
            if (i < 0) {
              this.skippedProducts.push(val);
            }
          }
        }
      });
      this.calculateTotal();
    }
    this.totalRecrringBottlesCount = this.currentWeekRecurringProducts.filter(el => el['product']['bottle_charge']).reduce((a, val) => a + parseFloat(val['quantity']), 0);
  }
  calculateAvailableQuantityFast(product) {
    var availableQuantities = [];
    if (product['product']['website_min_qty'] !== '' && product['product']['website_max_qty'] !== '') {
      if (product['product']['cb_unit_of_measurement']['name'] === 'Quantity in Nos') {
        for (let i = parseInt(product['product']['website_min_qty'], 10); i <= parseInt(product['product']['website_max_qty'], 10); i++) {
          availableQuantities.push(i);
        }
      } else if (product['product']['cb_unit_of_measurement']['name'] === 'Weight in 1lbs') {
        for (let i = parseFloat(product['product']['website_min_qty']); i <= parseFloat(product['product']['website_max_qty']); i += 0.5) {
          availableQuantities.push(i);
        }
      }
    } else if (product['product']['website_min_qty'] !== '' && (product['product']['website_max_qty'] === '' || product['product']['website_max_qty'] === 0)) {
      if (product['product']['cb_unit_of_measurement']['name'] === 'Quantity in Nos') {
        availableQuantities = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
          18, 19, 20, 21, 22, 23, 24, 25
        ];
      } else if (product['product']['cb_unit_of_measurement']['name'] === 'Weight in 1lbs') {
        availableQuantities = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];
      }
    } else if (product['product']['cb_unit_of_measurement']['name'] === 'Quantity in Nos') {
      availableQuantities = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
        18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
        35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
        52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
        69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100
      ];
    } else if (product['product']['cb_unit_of_measurement']['name'] === 'Weight in 1lbs') {
      availableQuantities = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10];
    }
    return availableQuantities;

  }
  calculateTotal() {
    if (this.apiService.loggedIn() === false) {
      this.totalBottlePrice = (this.totalBottlesCount * this.storeDetails['rate_per_bottle']);
    }
    if (this.apiService.loggedIn() === true) {
      // this.totalRecrringBottlesCount = this.currentWeekRecurringProducts.reduce((a, val) => a +  parseFloat(val['bottleQty']), 0);
      this.totalRecrringBottlesCount = this.currentWeekRecurringProducts.filter(el => el['product']['bottle_charge']).reduce((a, val) => a + parseInt(val['quantity']), 0);
      this.totalCartBottlesCount = this.cartProducts.reduce((a, val) => a + parseInt(val['bottleQty']), 0);
      this.totalBottlesCount = this.totalRecrringBottlesCount + this.totalCartBottlesCount;
      this.totalBottlePrice = (this.totalBottlesCount * this.storeDetails['rate_per_bottle']);
      if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
      this.cartProductPrice = this.cartProducts.reduce((a, val) => {
        let price = !!val['product']['sell_in_uof'] && val['product']['sell_in_uof'] === 'unit' ? this.decimalPipe.transform(this.decimalPipe.transform(val['product']['sell_in_conv_rate'] * val['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(val['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
        return a + parseFloat(price);
      }, 0);
        }else{
          this.cartProductPrice = this.cartProducts.reduce((a, val) => {
            let price = !!val['product']['sell_in_uof'] && val['product']['sell_in_uof'] === 'nos' ? this.decimalPipe.transform(this.decimalPipe.transform(val['product']['sell_in_conv_rate'] * val['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(val['extendedprice'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
            return a + parseFloat(price);
          }, 0);     
  
        }
      this.recurringSubTotal = this.currentWeekRecurringProducts.reduce((a, val) => a + parseFloat(this.decimalPipe.transform(this.decimalPipe.transform(val['extended_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '')), 0);
      this.subTotal = this.recurringSubTotal + this.cartProductPrice;

    }
    // this.calculateAmtDiffForFreeDelivery();
    this.grandTotal = this.totalBottlePrice + this.subTotal + this.deliveryFee;
    if (this.totalTaxCollectedAmount > 0) {
      this.grandTotal = this.grandTotal + this.totalTaxCollectedAmount;
    }
  }
  public showToolTip(bottlesTooltip) {
    bottlesTooltip.toggle();
    setTimeout(() => bottlesTooltip.hide(), 4000);
  }
  getVendorMatch(data) {
    const index = this.vendors.findIndex(el => el['id'] === parseInt(data));
    return this.vendors[index]['vendor_name'];
  }
  getcategoryMatch(data) {
    const index = this.categories.findIndex(val => val['category_url'] === data)
    this.category = index >= 0 ? this.getCategoryOrSubCategory(data, this.categories) :
      this.categories.reduce((arr, item) => arr.concat(item.sub_list), []).find(sub => sub.category_url === data);
    return this.category;
  }
  getCategories() {
    this.apiService.categories()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        this.subscription.subjectNext({ categories: result['response']['data']['cat_list'] });
        this.setCategoryValue();
        this.categories = result['response']['data']['cat_list'];
        this.setBreadcrumb();
        this.innerHtml = `${this.category['category_name']} <i class="material-icons " data-icon="arrow_drop_down vert-align"></i>`
        this.categoriesToolbar();

        if (this.params['parentCategory']) {
          let parentCategory = this.router.url.split('/').length === 3 && this.router.url !== '/categories' && this.router.url.includes('categories') ? this.categories.filter(val => val['category_url'] === this.router.url.split('/')[2]) : undefined;
          this.category['category_name'] = !!parentCategory && parentCategory.length !== 0 ? parentCategory[0]['category_name'] : ''
        }

        this.adjustCategoriesBasedOnScreen(this.categories);

      }
    }, (error) => {
      if (error) {
        console.log(error);
      }
    });
  }
  public getBrands() {
    this.apiService.getVendor()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result['response']['status'] === 1) {
        this.vendors = result['response']['data']['vendor_list'];
      }
    }, (error) => {
      console.log(error);
    });
  }
  public changeCategory(event) {
    if (event['event'] && event['event'].target && event['category']['id'] !== -1) {
      this.category = this.categories.filter(category => category.id === event.category.id)[0] ? this.categories.filter(category => category.id === event.category.id)[0] :
        this.categories.reduce((arr, item) => arr.concat(item.sub_list), []).find(sub => sub.id === event.category.id);
      this.innerHtml = `${this.category['category_name']} <i class="material-icons " data-icon="arrow_drop_down vert-align"></i>`

    } else {
      this.setCategoryValue();
      this.router.navigate(['categories']);
    }
    if (window.innerWidth < 960) {
      this.stopClickPropagate(event);
    }
  }

  public remove(product) {
    const dialogRef = this.dialog.open(DeleteCartComponent, {
      width: '450px',
      data: product
    });
    dialogRef.afterClosed()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result) {
        if (result['value'] === 'delete') {
          if (this.loggedIn === true) {
            this.notification.success('Selected Product has been deleted', 5000);
            this.subscription.subjectNext({ singleCartDelete: 'true', msg: "get shopping cart status bar data" });
          }
          if (this.loggedIn === false) {
            this.getLocalStorage();
            this.notification.success('Selected Product has been deleted', 5000);
            this.subscription.subjectNext({ msg: "get shopping cart status bar data" });
          }
        }
      }

    });
    // this.getCartDetails();
  }

  public clear() {
    const dialogRef = this.dialog.open(DeleteCartComponent, {
      width: '450px',
      data: { value: 'clear all' }
    });
    dialogRef.afterClosed()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      if (result) {
        if (result['value'] === 'delete') {
          if (this.loggedIn === true) {
            this.subscription.subjectNext({ info: 'cart delete all' });
          }
          if (this.loggedIn === false) {
            this.cartProducts = [];
            this.subscription.subjectNext({ info: 'cart delete all' });
          }
        }
      }

    });
  }

  public changeTheme(theme) {
    this.settings.theme = theme;
  }

  public stopClickPropagate(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  search(value) {
    const keyword = value['keyword'] ? value['keyword'].trim() : '';

    if (keyword !== '' || (this.category && this.category['category_name'] !== 'All Categories')) {
      if (this.category) {
        this.searchForm.value['cat'] = this.category['category_url'];
      }

      this.searchForm.value['keyword'] = keyword;
      this.searchForm.value['breadcrumb'] = this.category?.['category_name']?.replace(/[\s&/]+/g, '-');

      // Navigate with category parameter
      this.router.navigate(['products/search', this.searchForm.value['cat']], {
        queryParams: this.searchForm.value,
        state: { breadcrumb: this.category?.['category_name'] }
      }).then(() => {
        setTimeout(() => this.categoriesToolbar(), 0);
      });
    } else if (keyword === '' && this.category?.['category_name'] === 'All Categories') {
      this.router.navigate(['categories']);
    }
  }


  mobileSearch(value) {
    this.setCategoryValue();
    this.search(value);
  }

  goToCart() {
    if (JSON.parse(sessionStorage.getItem('cart')) !== null) {
      this.localStorageCartProd = JSON.parse(sessionStorage.getItem('cart'));
      if (this.localStorageCartProd.length > 0) {
        var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
        this.router.navigate(['sign-in'], queryParams);
      }
    }
  }
  // @HostListener('window:scroll', ['$event'])
  // onWindowScroll($event) {
  //   ($event.target.documentElement.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;
  // }
  ngAfterViewInit() {
    // this.subcategoriesMenu.forEach((trigger: MatMenuTrigger) => {
    //   trigger.menuOpened.subscribe(() => {
    //     if (trigger.overlayRef) {
    //       // Disable the backdrop for each menu
    //       trigger.overlayRef.backdropElement = null;
    //     }
    //   });
    // });
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.sidenav) {
          this.sidenav.close();
        }

        if(isPlatformBrowser(this.platformId)) {
        // the navigation is changed then set scrollTop in 0,0
          const contentContainer = document.querySelector('.mat-sidenav-content');
          if (contentContainer) {
            document.querySelector('.mat-sidenav-content').scroll({ top: 0, left: 0, behavior: 'smooth' });
          } else {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
          }
        }
        // end
      }
    });
    this.appHeaderService.setupAppHeader(this.storeDetailsJson, this.categories, this.vendors);
    this.adjustCategoriesBasedOnScreen();
  }

  ngOnDestroy() {
    this.sub && this.sub.unsubscribe();
    this.routerSubscription && this.routerSubscription.unsubscribe();
    !!this.subService && this.subService.unsubscribe();
    !!this.loginSubService && this.loginSubService.unsubscribe();

    if(this.Evsubscription){
      this.Evsubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }


  public closeSubMenus(value: string = null) {
    if (value && value === 'category') {
      this.setCategoryValue();
    }
    if (window.innerWidth < 960) {
      this.sidenavMenuService.closeAllSubMenus();
    }
  }
  getLocalStorage() {
    if (JSON.parse(sessionStorage.getItem('cart')) !== null && JSON.parse(sessionStorage.getItem('cart')).length !== 0) {

      this.localStorageDetails = getLocalStorage(this.storeDetails, this.decimalPipe);
      this.cartProducts = this.localStorageDetails['cartProducts'];
      if(!!this.featureTags && this.featureTags['sf_nos_to_unit']){
      this.cartProductPrice = this.cartProducts.reduce((total, currentValue) => {
          let price = !!currentValue['product']['sell_in_uof'] && currentValue['product']['sell_in_uof'] === 'unit' ? this.decimalPipe.transform(this.decimalPipe.transform(currentValue['product']['sell_in_conv_rate'] * currentValue['quantity'] * currentValue['product']['retail_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(currentValue['quantity'] * currentValue['product']['retail_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
          return total + parseFloat(price);
        }, 0);
        }else{
          this.cartProductPrice = this.cartProducts.reduce((total, currentValue) => {
            let price = !!currentValue['product']['sell_in_uof'] && currentValue['product']['sell_in_uof'] === 'nos' ? this.decimalPipe.transform(this.decimalPipe.transform(currentValue['product']['sell_in_conv_rate'] * currentValue['quantity'] * currentValue['product']['retail_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '') : this.decimalPipe.transform(this.decimalPipe.transform(currentValue['quantity'] * currentValue['product']['retail_price'], '1.2-4').replace(/,/g, ''), '1.2-2').replace(/,/g, '');
            return total + parseFloat(price);
          }, 0);
        }
      this.totalBottles = this.cartProducts.filter(val => {
        if (val['product']['bottle_charge'] === true) {
          return val['quantity'];
        }
      });
      this.totalBottlesCount = this.totalBottles.reduce((a, val) => a + val['quantity'], 0);
      if (!this.storeDetails['rate_per_bottle']) {
        this.calculateTotal();
      }
      this.subTotal = this.cartProductPrice;
      this.deliveryFee = this.storeDetails['delivery_fee'];
      if (this.subTotal >= this.storeDetails['delivery_upper_limit'] && this.storeDetails['delivery_fee'] > 0) {
        this.deliveryFee = 0;
      }
      this.calculateTotal();
      this.totalPrice = this.localStorageDetails['grandTotal'];
      this.totalCartCount = this.localStorageDetails['cartProducts'].length;
    } else {
      this.totalCartCount = 0;
      this.totalPrice = 0;
      this.cartProducts = [];
    }

  }
  handleChange(event) {
    // this.getLocalStorage();
    // this.getCartDetails();
    if (event && event['id'] !== -1 && !event['title'] && !event['name']) {
      this.category = !event['parent_id'] ? this.categories.filter(category => category.category_name === event.category_name)[0] :
        this.categories.reduce((arr, item) => arr.concat(item.sub_list), []).find(sub => sub.category_name === event.category_name);
      this.innerHtml = `${this.category['category_name']} <i class="material-icons " data-icon="arrow_drop_down vert-align"></i>`
      var url = event['parentCategory'] !== '' ? ['/categories', event['parentCategory']['category_url'], this.category['category_url']] : ['/categories', this.category['category_url']];
      this.router.navigate(url);
    } else if (event['title']) {
      this.router.navigate([event['title']['href']]);
    } else if(event["name"] && event["name"] === "Logout"){
      try {
        let sessionRestore = ["store", "storeLinks","featureTags"]; //"featureTags"
        let sessionRestoreArray = {};
        this.apiService.logout()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (data) => {
            if (data["response"]["status"] === 1) {
              sessionRestore.forEach((element) => {
                sessionRestoreArray[element] =
                  sessionStorage.getItem(element);
              });
              // sessionStorage.clear();
              sessionStorage.removeItem('booking_start_date');
              sessionStorage.removeItem('calendar_data_last');
              sessionStorage.removeItem('cardEnable');
              sessionStorage.removeItem('cart');
              sessionStorage.removeItem('cutoff');
              sessionStorage.removeItem('order_exist');
              sessionStorage.removeItem('cardEnable');
              sessionStorage.removeItem('recurring_frequencies');
              sessionStorage.removeItem('selected_delivery_calendar');
              sessionStorage.removeItem('selected_delivery_date');
              sessionStorage.removeItem('event_details');
              sessionStorage.removeItem('upcoming_event_dates');
              localStorage.clear();
              this.apiService.setLogin({
                loggedIn: false,
                userDetails: null,
              });
              this.resetSession(sessionRestoreArray);
              this.subscription.subjectNext({ msg: "logged out" });
              this.sharedDataService.cartDataSource.next(false);
              // window.location.reload();
              var queryParams = this.router.url.includes("cart")
                ? { queryParams: { redirectURL: this.router.url } }
                : {};
              this.router.navigate(["/sign-in"], queryParams);
              this.notification.success(
                data["response"]["message"],
                5000
              );
            } else {
              this.notification.error(
                data["response"]["message"],
                5000
              );
            }
          },
          (err) => {
            console.log("get user details error", err);
          }
        );
      } catch (error) {
        console.log(error);
      }
    } else if (event['name']) {
      if (event['href'] !== null && !event['category_url']) {
        this.category = event['name'] === 'All Categories' ? {
          id: -1,
          'category_url': 'All_Categories',
          parentId: 0,
          'category_name': 'All Categories',
          'sub_list': []
        } : this.category;
        this.router.navigate([event['href']]);
      } else if (event['href'] !== null && event['category_url']) {
        this.router.navigate(['/categories', event['category_url']]);
      }
    } else {
      this.setCategoryValue();
      this.router.navigate(['categories']);
    }
    setTimeout(() => {
      if (this.sidenav) {
        this.sidenav.close();
      }
    }, 2000);

  }
  viewCart() {
    if (!this.loggedIn) {
      return this.router.navigate(['cart']);
    }
    if (checkLessThanCutOffTime() === true) {
      const dialogRef = this.dialog.open(PopupComponent, {
        width: '450px',
        data: { display: `You have crossed the ordering cutoff time for your delivery dated ${this.datePipe.transform(sessionStorage.getItem('selected_delivery_date'), 'MM/dd')}. Please email us ${sessionStorage.getItem('stemail')} OR call us at ${sessionStorage.getItem('stphone')} for help.`, msg: 'cut off time error' }
      });
      dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result && result === 'close') {
          this.router.navigate(['account/orders']);
        }
      });
      return;
    }
    this.router.navigate(['cart']);

  }

  imageErrorHandler(event) {
    event.target.src = "https://1dev-order.homemilkdelivery.com/img/no_image_found.png";
  }

  profileImageErrorHandler(event) {
    event.target.src = "assets/images/default-avatar.png";
  }

  // category toolbar start
  showCategoryToolbar() {
    let routesName = explode(this.router.url, '/');
    if (routesName[1] === "categories" && routesName.length > 2) {
      return true;
    } else {
      this.categoryToolbarDatas = null;
      return false;
    }
  }

  categoriesToolbar() {
    this.categoryToolbarDatas = null;
    let url = this.router.url;
    let routesName = explode(url, '/');
    if (routesName[1] === "categories" && routesName.length > 2) {
      !routesName[2].includes("search?keyword") && this.parseCategoryUrl(routesName);
    }
  }

  parseCategoryUrl(routesName: Array<any>) {
    let parentCategory = null;
    let childCategory = null;
    let categoryUrls = [
      {
        url: "/categories",
        label: "All Categories",
        display: false,
        navigation: true
      }
    ];
    parentCategory = this.getCategoryOrSubCategory(routesName[2], this.categories);
    if (routesName.length > 3) {
      childCategory = this.getCategoryOrSubCategory(routesName[3], parentCategory['sub_list']);
    }
    if (routesName.length > 3 && isNaN(parseInt(routesName[3])) === false) {
      parentCategory = undefined;
      childCategory = undefined;
    }
    if (!!parentCategory) {
      let parentUrl = implode(routesName.slice(0, 2), '/');
      categoryUrls.push({
        url: `${parentUrl}/${parentCategory['category_url']}`,
        label: parentCategory['category_name'],
        display: true,
        navigation: true
      });
    }
    if (!!childCategory) {
      categoryUrls.push({
        url: implode(routesName, '/'),
        label: childCategory['category_name'],
        display: true,
        navigation: false
      });
    }
    this.categoryToolbarDatas = categoryUrls;
  }

  getCategoryOrSubCategory(url: string, categoryList: Array<any>) {
    let resData = null;
    categoryList.length > 0 && categoryList.some((data, index) => {
      resData = data;
      if (!!url && !!data && !!data['category_url']) {
        return url.toLowerCase() === (data['category_url']).toLowerCase();
      }
    });
    return resData;
  }

  navigateCategoryUrl() {
    this.categoryToolbarDatas.pop();
    let categoryUrl = this.categoryToolbarDatas.slice(-1);
    categoryUrl.length > 0 && this.router.navigate([categoryUrl[0]['url']]);
  }
  // category toolbar end
  checkCutofftime(): boolean {
    if (checkDeliveryCalenderAndCutOffTime() === true) {
      return true;
    } else {
      return false;
    }
  }
  getUrl(isNotCategory, mainLink, subLink) {

    if (isNotCategory) {
      return ['/', mainLink];
    } else {
      // let params = subLink.split('/');
      // let link = ['/categories'];
      // params.forEach((el) => {
      //   link.push(el);
      // });
      let eachCategory = "/" + subLink;
      let baseCategory = "/categories";
      let categoryUrl = baseCategory.concat(eachCategory);
      let categoryUrlFormat = [];
      categoryUrlFormat.push(categoryUrl);

      return categoryUrlFormat;
    }
  }
  SearchProductsFn() {
    this.isShowSearch = !this.isShowSearch;
    localStorage.setItem('checkVal', JSON.stringify(this.isShowSearch));
  }
  enableRMenu() {
    this.router.navigate(['cart']);
    return;
    this.enableRSMenu = !this.enableRSMenu;
  }
  // goCms(link) {
  //   if (link['title']['name'] == 'Shop') {
  //     this.router.navigate(['/home']);
  //   } else if ( link['title']['href'] == 'vendors') {
  //       if(this.featureTags["new_vendor_page_in_ngsf"]){
  //         this.router.navigate(['/vendors']);
  //       } else {
  //         this.router.navigate(['']);
  //       }     
  //   }
  // }
  goCms(link) {
    if (link['title']['name'] == 'Shop') {
      this.router.navigate(['/shop']);
    } else if (link['title']['href'] == 'vendors') {
      if(this.featureTags && this.featureTags['ftag_sf_manufacturer_list']){
        this.router.navigate(['/producers']);
      }else{
        this.router.navigate(['/vendors']);
      }
    } else if (link['title']['name'] == 'About Us') {
      this.router.navigate(['about-us'])
      this.GetCMSPage('about-us');
    } else if (link['title']['name'] == 'Our Services') {
      this.router.navigate(['our-services'])
      this.GetCMSPage('our-services');
    } else if (link['title']['name'] == 'The Market') {
      this.router.navigate(['themarket'])
      this.GetCMSPage('themarket');
    }
  }
  GetCMSPage(name) {
    this.apiService.setLoader(true);
  }
  getClass() {    
    return this.activatedRoute['snapshot']['firstChild']['data']['title'] == 'All Categories' ? 'IsProductsPage' : 'DefaultView';
  }
  cutomizeMenuDetails(Menu) {

    this.apiService.categories()
    .pipe(takeUntil(this.destroy$))
    .subscribe(result => {
      let arr = [];
      arr = [...result['response']['data']['cat_list']];

      // let sortedProducts = arr.sort(
      //   (p1, p2) => (p1.id < p2.id) ? 1 : (p1.id > p2.id) ? -1 : 0);

      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      // const calculatedValue = this.screenWidth * 0.01;
      const calculatedValueHeight = this.screenHeight * 0.01;
      // const maxwidth = 5;
      // console.log("width", this.screenWidth, "Height", this.screenHeight, "screen calc", calculatedValue, calculatedValueHeight, sortedProducts.length)
      // var wholenum = Math.floor(calculatedValue);
      var wholenumHeight = Math.floor(calculatedValueHeight);

      var data = [{
        title: "PRODUCTS"
      }]
      this.MenusHeight['sortedHeight'] = [...data, ...arr.slice(0, 5)];
      this.MenusHeight['sortedHeight'].push({ category_name: "ALL CATEGORY", category_url: "" });

      // this.Menus['sortedLinks'].forEach(obj => {
      //   obj['category_name'].length > maxwidth ? obj['category_name_load'] = obj['category_name'].substring(0, maxwidth) + '...' : obj['category_name_load'] = obj['category_name'];
      //   console.log("check objecct trimmmmmmmmmmmmmmmmm else", obj['category_name_load']);
      // });
      let width
      let totalWidth = 0;
      let indexToRemove = -1;
      let chk = true;
      var chkwidth = this.screenWidth;
      var finwidth = chkwidth - 500;
      // Calculate total width of menu items
      arr.forEach((word, index) => {
        width = this.getTextWidth(word.category_name, '16px Arial'); // Adjust font size and type as needed
        this.wordWidths.set(word.category_name, width);
        totalWidth += this.wordWidths.get(word.category_name);
        if (totalWidth > finwidth && chk) {
          indexToRemove = index;
          chk = false;
        } else if (chk) {
          indexToRemove = -1;
        }
      });
      if (indexToRemove !== -1) {
        arr.splice(indexToRemove, arr.length - indexToRemove);
        this.Menus['sortedLinks'] = arr;
      } else {
        this.Menus['sortedLinks'] = arr
      }
      this.Menus.title = [{ title: "ALL CATEGORY", url: "categories" }, { title: "CONTACT US", url: "contact" }]

    })


    return Menu;
  }


  getTextWidth(text: string, font: string): number {
    if (isPlatformBrowser(this.platformId)) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = font;
      return context.measureText(text).width;
    }
    // Return a default or estimated width for the server-side
    return 0; // or any other logic you need
  }

  onClickSearch() {
    localStorage.setItem('checkVal', JSON.stringify(false));
  }

  isCartOrOrdersPage(): boolean {
    if (true) {
      const currentUrl = this.router.url;
      return currentUrl === '/edit-order' || currentUrl === '/account/orders' || currentUrl === '/account/pre-orders' || currentUrl === '/account/recurring';
    }
  }

  newcutomizeMenuDetails(Menu) {
    this.adjustCategoriesBasedOnScreen();

    return Menu;
  }




  @HostListener('window:resize', ['$event'])
  onResize() {

    this.adjustCategoriesBasedOnScreen();
  }

  adjustCategoriesBasedOnScreen(setCategories?: any) {
    if (this.featureTags && this.featureTags['sf_desktop_sub_cat']) {
      const screenWidth = window.innerWidth;
      const minWidthPerCategory = 210; // Minimum width per category (adjust as needed)
  
      let allCategories = this.categories || setCategories;
      if(!!this.featureTags && this.featureTags['sf_hide_previously_ordered']){
        if (this.loggedIn) {
          const previouslyOrderedCategory = {
            count: 0,
            id: 0,
            category_name: 'Previously Ordered',
            category_image: '',
            category_url: 'previously-ordered',
          };
              const alreadyIncluded = allCategories.some(
                (category) => category.category_name === 'Previously Ordered',
              );
              if (!alreadyIncluded) {
                allCategories = [previouslyOrderedCategory, ...allCategories];
              }
              } else {
        
                allCategories = allCategories.filter(
                  (category) => category.category_name !== 'Previously Ordered',
                );
              }

              this.categories = allCategories;
      }


      // Prepare the "ALL" category
      const allCategory = { category_name: "MENU", category_url: "", sub_list: [] };
      
      allCategories = allCategories.filter(cat => cat.category_name !== "MENU");

      // Ensure "ALL" is the first category
      if (!allCategories[0] || allCategories[0].category_name !== "MENU") {
        allCategories.unshift(allCategory);
      }
  
      // Calculate how many categories fit the screen width
      let maxCategoriesToShow = Math.floor(screenWidth / minWidthPerCategory);
  
      // Truncate the categories based on screen width
      let truncatedCategories = allCategories.slice(0, maxCategoriesToShow);
      let updatedCategories =[]
      // Prepare static menus
      // const updatedCategories = this.categories.map(({ sub_list, ...rest }) => rest);
      if(!!this.featureTags && this.featureTags['sf_hide_previously_ordered']){
        updatedCategories = this.categories
      .filter(({ category_name }) => category_name !== "Previously Ordered")
      .map(({ sub_list, ...rest }) => rest);
      }else{
      updatedCategories = this.categories.map(({ sub_list, ...rest }) => rest);
      }
  
      const staticMenus = [
        { category_name: "all categories", category_url: "categories", sub_list: updatedCategories },
      ];

      this.categories = allCategories;
      
      // Combine truncated categories with static menus at the end
      this.Menus['sortedLinks'] = [...truncatedCategories, ...staticMenus];
    }
  }


  setFavicons() {
    const themeLower = this.settings['themeType'].toLowerCase(); // Convert theme to lowercase
    const finalTheme = themeLower === 'default' ? 'global-theme' : themeLower; // Check for 'default'
    this.styleService.applyTheme(finalTheme);
    const basePath = `assets/${finalTheme}/files/images/3/content-images/favicons`;  
    
    const icons = {
      faviconJpg: `${basePath}/favicon.jpg`,
      appleTouchIcon: `${basePath}/apple-touch-icon.png`,
      favicon32: `${basePath}/favicon-32x32.png`,
      favicon16: `${basePath}/favicon-16x16.png`,
      manifest: `${basePath}/site.webmanifest`,
      maskIcon: `${basePath}/safari-pinned-tab.svg`
    };
  
    // Update each favicon dynamically
    this.updateLink('faviconJpg', icons.faviconJpg);
    this.updateLink('appleTouchIcon', icons.appleTouchIcon);
    this.updateLink('favicon32', icons.favicon32);
    this.updateLink('favicon16', icons.favicon16);
    this.updateLink('manifest', icons.manifest);
    this.updateLink('maskIcon', icons.maskIcon);
  }
  
  updateLink(id: string, href: string) {
    const link: HTMLLinkElement = this.document.getElementById(id) as HTMLLinkElement;    
    if (link) {
      link.href = `${href}?v=${new Date().getTime()}`; // Avoid caching issues
    } else {
      console.warn(`Link with id ${id} not found.`);
    }
  }
  
  getOrdercountDetails() {
    this.sharedDataService.getOrderData();
  }

  getDeliveryDates() {
    // this.sharedDataService.getDeliveryData();
  }

  resetSession(sessionRestoreArray) {
    try {
      for (let [key, value] of Object.entries(sessionRestoreArray)) {
        sessionStorage.setItem(key, JSON.stringify(JSON.parse(value as string)));
      }
    } catch (error) {
      console.log(error)
    }
  }
  openDropdown(nav: any) {
    nav.isOpen = true;
  }
  
  closeDropdown(nav: any) {
    nav.isOpen = false;
  }
  
}




